<template>
    <div class="dateExplain">
		<p>*以上视图与表格内数据仅为根据您输入的查询条件查询后展示的结果 </p>
	<!-- <p>*如您需要以上查询字段以外的内容请点击这里<a href="javascript:;">下载全表格</a>，查收您权限内可查阅的数据。</p> -->
	</div>
</template>

<script>
export default {
    name: 'tips'
}
</script>